// extracted by mini-css-extract-plugin
export var content = "_o1-1";
export var fullScreen = "_o1-0";